export default __webpack_public_path__ + "static/media/product3.766fe3e5.png";